module.exports = __webpack_public_path__ + "static/media/Password.15f54a70.png";